const ShopSkinComponent = () => import('@/views/shop/ShopSkin/ShopSkinView')

export default [
    {
        path:'/ShopSkinIndex',
        name:'ShopSkinRouter',
        component:ShopSkinComponent
    }
]